module.exports = __webpack_public_path__ + "static/media/safari-head-1.ad23dcb7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/Assets/img/safari-head-1.svg
// module id = 1019
// module chunks = 0